import ReactGA from 'react-ga4'
import { BrowserRouter } from 'react-router-dom'

import { RoutesWrapper } from 'libraries/router'
import { MEASUREMENT_ID } from 'types'

import './styles/local.scss'
import 'swiper/css'
import '@leenguyen/react-flip-clock-countdown/dist/index.css'

ReactGA.initialize(MEASUREMENT_ID)

const App = () => (
  <BrowserRouter>
    <RoutesWrapper />
  </BrowserRouter>
)

export default App
